<template>
  <button
    :aria-expanded="isMenuOpen"
    aria-controls="mobile-menu"
    :class="{ 'is-open': isMenuOpen }"
    class="menu-toggle flex items-center justify-end mr-3 cursor-pointer"
    @click="toggleMenu"
  >
    <span class="sr-only">{{ isMenuOpen ? 'Close menu' : 'Open menu' }}</span>
    <div class="lines">
      <span/>
      <span/>
      <span/>
    </div>
  </button>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, watch } from 'vue'

const isMenuOpen = ref(false)

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

const updateMenuClass = () => {
  const mobileMenu = document.getElementById('mobile-menu')
  if (mobileMenu) {
    mobileMenu.classList.toggle('menu-open', isMenuOpen.value)
  }
  document.body.classList.toggle('no-scroll', isMenuOpen.value)
  document.body.classList.toggle('menu-open', isMenuOpen.value)
}

const handleResize = () => {
  const isDesktop = window.matchMedia('(min-width: 1366px)').matches
  if (isDesktop && isMenuOpen.value) {
    isMenuOpen.value = false
    updateMenuClass()
  }
}

watch(isMenuOpen, updateMenuClass)

onMounted(() => {
  const mobileMenu = document.getElementById('mobile-menu')
  if (mobileMenu && mobileMenu.classList.contains('menu-open')) {
    isMenuOpen.value = true
  }
  window.addEventListener('menu-close', () => {
    isMenuOpen.value = false
  })
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped>
.menu-toggle {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.lines {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}

.lines span {
  display: block;
  height: 4px;
  width: 100%;
  background-color: black;
  transition: all 0.3s ease;
  transform-origin: center;
}

.menu-toggle.is-open .lines span:nth-child(1) {
  transform: translateY(10px) rotate(45deg);
}
.menu-toggle.is-open .lines span:nth-child(2) {
  opacity: 0;
}
.menu-toggle.is-open .lines span:nth-child(3) {
  transform: translateY(-10px) rotate(-45deg);
}

.menu-toggle .lines span:nth-child(1) {
  transform: translateY(0) rotate(0);
}
.menu-toggle .lines span:nth-child(2) {
  opacity: 1;
}
.menu-toggle .lines span:nth-child(3) {
  transform: translateY(0) rotate(0);
}
</style>
